import { v4 as uuid } from "uuid";

import { PRACTICE_SLUG } from "models";

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * TODO (Alp): Remove this after Soil+ 3.0 is done
 */
export const FERTILIZER_BUNDLE_SLUGS = [PRACTICE_SLUG.MINERAL_FERTILIZERS, PRACTICE_SLUG.ORGANIC_FERTILIZERS];

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * TODO (Alp): Remove this after Soil+ 3.0 is done
 */
export const TILLAGE_SEEDING_BUNDLE_SLUGS = [PRACTICE_SLUG.TILLAGES, PRACTICE_SLUG.SEEDINGS];

export const TILLAGE_BLANK_PRACTICE = (cropId: string) =>
  ({
    id: uuid(),
    key: Date.now().toString(),
    type: PRACTICE_SLUG.TILLAGES,
    endDate: "",
    cropId,
    assignedPracticeId: "",
    payout: 0,
    isConfirmed: false,
    year: 0,
    soilPlus3DataCollection: false,
    tillageDepthSoilPlus3DataCollection: false,
    fallbackDates: { startDate: null, endDate: null },
  }) as const;

export const CROP_RESIDUE_TYPES = {
  STRAW: "straw",
  STOVER: "stover",
  BIOMASS: "biomass",
  FOLIAGE: "foliage",
} as const;

export type CropResidueType = (typeof CROP_RESIDUE_TYPES)[keyof typeof CROP_RESIDUE_TYPES];

export const ANIMAL_BASED_FERTILIZER_SLUGS = new Set([
  "cattle_slurry",
  "cattle_slurry_solid_fraction_from_separated_slurry",
  "gülle_rind_feste_fraktion_aus_separierter_gülle",
  "jauche",
  "manure_cattle_horse_sheep_goat_fresh",
  "manure_cattle_horse_sheep_goat_rotted",
  "manure_cattle_horse_sheep_goat_composted",
  "mist_rind_pferd_schaf_ziege_verrottet",
  "mist_rind_pferd_schaf_ziege_kompostiert",
  "pig_slurry",
  "gülle_schweingeflügel_feste_fraktion_aus_separierter_gülle",
  "dung_pig_fresh",
  "dung_pig_rotted",
  "dung_pig_composted",
  "mist_schwein_verrottet",
  "mist_schwein_kompostiert",
  "manure_poultry_rabbit_fresh",
  "manure_poultry_rabbit_rotted",
  "manure_poultry_rabbit_composted",
  "mist_geflügel_kaninchen_verrottet",
  "mist_geflügel_kaninchen_kompostiert",
  "poultry_manure",
  "gülle_geflügel",
  "manure_pigpoultry_solid_fraction_from_separated_slurry",
]);

// ⚠ Options below need sign-off from the agronomy team before shipping
export const BIOMASS_INPUT_TYPE_OPTIONS = [
  "silage_maize",
  "clover_grass",
  "lucerne_grass",
  "grass",
  "whole_crop_silage",
  "food_waste",
  "green_cut_waste",
  "sewage_sludge",
  "fermentation_residue",
  "cattle_manure",
  "pig_manure",
  "poultry_manure",
  "horse_manure",
  "sheep_manure",
  "other",
] as const;

export const QUANTITY_UNIT_OPTIONS = ["m³", "t", "kg", "l"] as const;

// Buckets used when a carbon program does not require a precise tillage depth; the stored value is the bucket's lower bound
export const TILLAGE_DEPTH_RANGE_OPTIONS = [
  { value: 0, name: "0-5 cm" },
  { value: 5, name: "5-10 cm" },
  { value: 10, name: "10-30 cm" },
  { value: 30, name: "30-60 cm" },
  { value: 60, name: "60+ cm" },
];
